export function useState() {
    return {
        popupComponent: null,
        new: null,
        current: null,
        selected: null,
        loaded: false,
        listUrl: null,
        nextUrl: null,
        prevUrl: null,
        list: [],
        listMap: {},
        items: [],
        listActions: [],
        filterIsSet: 1,
        search: null,
        filter: {},
        params: {},
        refresh: [],
        loading: false,
        pagination: null,
        mapObjectsLoadUrl: null,
        mapObjectsLoaded: false,
        mapFilter: {},
        mapFilterIsSet: 1,
    }
}

export function useGetters() {
    return {
        current: state => state.current,
        new: state => state.new,
        selected: state => state.selected,
        listUrl: state => state.listUrl,
        list: state => state.list,
        items: state => state.items,
        find: state => (id) => findInList(state, id),
        findCurrent: state => findInList(state, state.current),
        get: state => (ids) => getFromList(state, ids),
        getIndex: state =>  (id) => findIndex(state, id),
        filterIsSet: state => state.filterIsSet,
        filter: state => state.filter,
        search: state => state.search,
        params: state => state.params,
        loading: state => state.loading,
        refresh: state => state.refresh,
        pagination: state => state.pagination,
        listActions: state => state.listActions,
        mapObjectsLoadUrl: state => state.mapObjectsLoadUrl,
        popupComponent: (state) => state.popupComponent,
        mapFilter: state => state.mapFilter,
        mapFilterIsSet: state => state.mapFilterIsSet,
        loaded: state => state.loaded,
        nextUrl: state => state.nextUrl,
        prevUrl: state => state.prevUrl,
        mapObjectsLoaded: state => state.mapObjectsLoaded,
    }
}

export function useMutators(methods = { update , remove }) {
    const { update, remove } = methods;
    return {
        new(state, object) {
            state.new = object;
        },

        current(state, id) {
            state.current = id;
        },

        filterIsSet(state, status) {
            state.filterIsSet = !!status ? 1 : 0;
        },

        listActions(state, actions) {
            state.listActions = actions;
        },

        filter(state, filter) {
            Object.assign(state.filter, filter);
        },

        search(state, search) {
            state.search = search;
        },

        setFilter(state, filter) {
            state.filter = filter;
        },

        select(state, id) {
            state.selected = id;
        },

        loading(state, status) {
            state.loading = status;
        },

        loaded(state, status) {
            state.loaded = status;
        },

        nextUrl(state, value) {
            state.nextUrl = value;
        },

        prevUrl(state, value) {
            state.prevUrl = value;
        },

        list(state, list) {
            state.list = list;
            list.forEach((item, index) => {
                if (typeof item.id === 'undefined') {
                    item.id = index;
                }
                state.listMap[item.id.toString()] = index;
            });
        },

        resetList(state) {
            state.loaded = false;
            state.nextUrl = state.listUrl;
        },

        refresh(state, list ) {
            state.refresh = [...new Set(list)]; // Distinct
        },

        clearRefreshList(state) {
            state.refresh = [];
        },

        clearList(state) {
            state.list = [];
            state.listMap = {};
            state.items = [];
        },

        addToList(state, item) {
            state.list.push(item);
            state.listMap[item.id.toString()] = state.list.length - 1;
        },

        prependToList(state, item) {
            state.list.unshift(item);

            state.listMap = {};
            state.list.forEach((item, index) => {
                state.listMap[item.id.toString()] = index;
            });
        },

        removeFromList(state, ids) {
            (Array.isArray(ids) ? ids : [ids]).forEach((id) => {
                const index = state.listMap[id.toString()];
                if (typeof index === 'undefined') return;
                remove(state, index);
            });
        },

        updateInList(state, item) {
            const index = state.listMap[item.id.toString()];
            if (typeof index === 'undefined') return;
            update(state, index, item);
        },

        updateOrAddToList(state, item) {
            const index = state.listMap[item.id.toString()];
            if (typeof index !== 'undefined') {
                return update(state, index, item);
            }

            state.list.push(item);
            state.listMap[item.id.toString()] = state.list.length - 1;
        },

        updateOrPrependToList(state, item) {
            const index = findIndex(state, item.id);
            if (index !== -1) return update(state, index, item);
            state.list.unshift(item);
        },

        pagination(state, pagination) {
            state.pagination = pagination;
        },

        setup(state, data) {
            Object.keys(data).forEach((key) => {
                state[key] = data[key];
            });
        },

        mapObjectsLoadUrl(state, url) {
            state.mapObjectsLoadUrl = url;
        },

        mapObjectsLoaded(state, status) {
            state.mapObjectsLoaded = status;
        },

        mapFilterIsSet(state, status) {
            state.mapFilterIsSet = !!status ? 1 : 0;
        },

        mapSettings(state, settings) {
            state.mapSettings = Object.assign(state.mapSettings, settings);
        },

        mapFilter(state, filter) {
            Object.assign(state.mapFilter, filter);
        },

        setMapFilter(state, filter) {
            state.mapFilter = filter;
        },
    }
}

export function useActions() {
    return {
        updateActiveStatus({ state, commit }, { ids, active}) {
            ids.forEach(id => {
                commit('updateInList', { id, active });
            });
        },
    };
}

//====================== Helper methods ===================

export function find(state, id) {
    return findInList(state, id);
}

export function findIndex(state, id) {
    return findIndexInList(state, id);
}

export function update(state, index, data) {
    const item = state.list[index];
    if (typeof item !== 'object') {
        console.warn(index, item);
        return;
    }
    Object.assign(item, data);
}

export function remove(state, index) {
    state.list.splice(index, 1);
    state.listMap = {};
    state.list.forEach((item, index) => {
        state.listMap[item.id.toString()] = index;
    });
}

export function getFromList(state, ids) {
    return ids.map(id => state.listMap[id.toString()]).map((index) => {
        return state.list[index];
    });
}

export function findInList(state, id) {
    if (typeof id === 'undefined' || id === null) return null;
    const index  = state.listMap[id.toString()];
    return state.list[index];
}

export function findIndexInList(state, id) {
    if (id === null) return -1;
    const index = state.listMap[id.toString()];
    return typeof index === 'undefined' ? -1 : index;
}